import { BoxProps, ButtonProps, ColorOptions, TextInputNewProps } from '@jfs/ui-new'
import { ViewStyle } from 'react-native'

const shadowStyle = {
  shadowOffset: { width: 1, height: 1 },
  shadowRadius: 3,
  shadowColor: '#0000001F',
  borderRadius: 8,
  borderWidth: 1,
  borderColor: '#00000014',
  zIndex: 10,
}

export const styles = () => {
  return {
    container: {
      flexDirection: 'row',
      justifyContent: 'flex-start',
      flexWrap: 'wrap',
      padding: 16,
      backgroundColor: 'WHITE',
    } as BoxProps,
    childContainer: {
      display: 'flex',
      flexDirection: 'row',
      paddingVertical: 12,
      minWidth: 150,
      alignItems: 'center',
      underlayColor: 'TRANSPARENT',
    } as BoxProps,
    innerContainer: {
      margin: 0,
      marginBottom: 12,
    } as BoxProps,
    topBar: {
      flexDirection: 'column',
      justifyContent: 'flex-start',
      padding: 16,
      // borderBottom: `solid 1px ${Theme.grey.GREY_SEPARATOR}`,
      borderBottomWidth: 1,
      borderStyle: 'solid',
      borderBottomColor: 'GREY_SEPARATOR',
    } as BoxProps,
    filterHeader: {
      flexDirection: 'row',
      justifyContent: 'center',
    } as BoxProps,
    outerContainer: {
      // border: `solid 1px ${Theme.grey.GREY_SEPARATOR}`,
      borderWidth: 1,
      borderColor: 'GREY_SEPARATOR',
      borderStyle: 'solid',
      borderRadius: 8,
      marginTop: 20,
      backgroundColor: 'WHITE',
    } as BoxProps,
    bottomFix: {
      borderBottomWidth: 0,
    } as BoxProps,
    bottomBar: {
      flexDirection: 'row',
      justifyContent: 'flex-end',
      padding: 16,
      // borderTop: `solid 1px ${Theme.grey.GREY_SEPARATOR}`,
      borderTopWidth: 1,
      borderTopColor: 'GREY_SEPARATOR',
      borderStyle: 'solid',
    } as BoxProps,
    apply: {
      type: 'primarySmall',
      paddingHorizontal: 8,
      borderRadius: 'SMALL',
      shadowType: 'shadowPrimary',
      borderWidth: 0,
      textType: 'body12',
    } as ButtonProps,
    cancel: {
      type: 'secondarySmall',
      paddingHorizontal: 8,
      borderRadius: 'SMALL',
      shadowType: 'shadowPrimary',
      borderWidth: 0,
      borderColor: 'WHITE',
      textType: 'body12',
    } as ButtonProps,
    restoreDefault: {
      paddingHorizontal: 8,
      type: 'secondarySmall',
      borderRadius: 'SMALL',
      borderColor: 'WHITE',
      shadowType: 'shadowPrimary',
      textType: 'body12',
    } as ButtonProps,
    contact: {
      type: 'body12',
      paddingHorizontal: 16,
      paddingVertical: 8,
      borderColor: 'GREY_BORDER' as ColorOptions,
      labelPaddingBottom: 8,
      borderRadius: 4,
    } as TextInputNewProps,
    email: {
      type: 'body12',
      paddingHorizontal: 16,
      paddingVertical: 8,
      borderColor: 'GREY_BORDER' as ColorOptions,
      labelPaddingBottom: 8,
      borderRadius: 4,
    } as TextInputNewProps,
    paymentLink: {
      type: 'body12',
      paddingHorizontal: 16,
      paddingVertical: 8,
      borderColor: 'GREY_BORDER' as ColorOptions,
      labelPaddingBottom: 8,
      borderRadius: 4,
    } as TextInputNewProps,
    clChildContainer: {
      display: 'flex',
      flexDirection: 'row',
      minWidth: 150,
      alignItems: 'center',
    } as BoxProps,
    searchText: {
      type: 'body12',
      paddingHorizontal: 16,
      paddingVertical: 5,
      borderColor: 'WHITE',
      labelPaddingBottom: 8,
      borderRadius: 4,
      focusBorderColor: 'WHITE',
      borderWidth: 0,
    } as TextInputNewProps,
    textStyle: {
      type: 'body12',
      paddingHorizontal: 16,
      paddingVertical: 5,
      borderColor: 'GREY_BORDER' as ColorOptions,
      labelPaddingBottom: 8,
      borderRadius: 4,
      focusBorderColor: 'GREY_BORDER' as ColorOptions,
      borderWidth: 0,
    } as TextInputNewProps,
    searchContainer: {
      display: 'flex',
      flexDirection: 'row',
      borderWidth: 1,
      borderColor: 'GREY_BORDER' as ColorOptions,
      borderRadius: 4,
    } as BoxProps,
    modal: {
      position: 'absolute',
      elevation: 2,
      shadowOpacity: 1,
      opacity: 1,
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      ...shadowStyle,
      zIndex: 1,
      borderWidth: 1,
      borderColor: '#00000014',
    } as unknown as BoxProps,
    overlayStyle: {
      backgroundColor: 'rgba(255,255,255,0)',
      width: '100%',
      height: '100%',
      justifyContent: 'center',
    } as ViewStyle,
    dropdownStyle: {
      position: 'absolute',
      flex: 1,
      shadowColor: '#000001',
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.3,
      shadowRadius: 10,
      elevation: 2,
      borderRadius: 12,
      backgroundColor: '#0186B0',
      borderColor: '#E1E5E8',
      alignSelf: 'center',
    } as unknown as BoxProps,
    calendarStyle: {
      height: '45%',
      w: '25%',
      position: 'absolute',
      bg: 'WHITE',
      ...shadowStyle,
    } as BoxProps,
    revocable: {
      flexWrap: 'wrap',
      maxHeight: 50,
    } as BoxProps,
  }
}
